// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/taf-cloud-and-weather-decode.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/taf-cloud-and-weather-decode/taf-cloud-and-weather-decode.js';

mount([g0]);
